/** Shared thirty-day outage presentation for raw DTC sensors. */
export function createOutageKpiConfig(
    urn: string,
    t: (key: string) => string,
) {
    const rawTrafficLight = {
        rules: [
            { severity: 'danger' as const, value: 200, when: 'gte' as const },
            { severity: 'warning' as const, value: 100, when: 'gte' as const },
        ],
        fallback: 'success' as const,
    };

    return {
        aggregation: 'max' as const,
        calc: ({ values }: { values: Record<string, number | null> }) => {
            const dtc = values[urn] ?? 0;
            return { 'calculated.status': dtc >= 200 ? 2 : dtc >= 100 ? 1 : 0 };
        },
        calcCode: `({ values }) => {
    // Maximum DTC within NOW-30DAYS to NOW; raw value remains visible in the legend.
    const dtc = values['${urn}'] ?? 0;
    return { 'calculated.status': dtc >= 200 ? 2 : dtc >= 100 ? 1 : 0 };
}`,
        legendSeries: urn,
        legendTrafficLight: rawTrafficLight,
        from: 'NOW-30DAYS',
        series: 'calculated.status',
        showLegend: true,
        title: t('Outage in last 30 days'),
        to: 'NOW',
        trafficLight: {
            rules: [
                { severity: 'danger' as const, value: 2, when: 'gte' as const },
                { severity: 'warning' as const, value: 1, when: 'gte' as const },
            ],
            fallback: 'success' as const,
        },
        urn,
        valueLabels: {
            values: {
                '0': t('No outage'),
                '1': t('Minor outage'),
                '2': t('Significant outage'),
            },
            fallback: '-',
        },
    };
}
